<template>
  <d2-container>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入活动标题"
        size="small"
        v-model="listQuery.keyword"
      ></el-input>
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.classifyId"
        clearable
        placeholder="请选择分类id"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
          v-for="item in asStatusList"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.status"
        clearable
        placeholder="请选择状态"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.type"
        clearable
        placeholder="请选择任务类型"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option
          v-for="item in showAppoinList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <!-- <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.asc"
        clearable
        placeholder="请选择顺序排列"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in ascs" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>-->
      <!-- <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.sortField"
        clearable
        placeholder="请选择顺序排列"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in sortFielList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>-->
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      v-permission:function="['punchTheClockDManger:btn_add']"
      @click="getAdd"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      @sort-change="changesa"
      highlight-current-row
      style=" margin-top: 20px"
      :data="themeData"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand2">
            <el-form-item label="报名人数:">
              <span style="color:rgb(64, 158, 255);">{{ props.row.joinCount || 0 }}</span>
            </el-form-item>
            <el-form-item label="完成人数:">
              <span style="color:rgb(64, 158, 255);">{{ props.row.doneCount || 0 }}</span>
            </el-form-item>
            <el-form-item label="完成率:">
              <span style="color:rgb(64, 158, 255);">{{ props.row.completionRate }}%</span>
            </el-form-item>
          </el-form>
          <el-form
            label-position="left"
            inline
            class="demo-table-expand"
            v-for="(item, index) in props.row.tasks"
            :key="index"
          >
            <el-form-item label="子任务id">
              <span style="color:rgb(64, 158, 255);">{{ item.id }}</span>
            </el-form-item>
            <el-form-item label="子任务标题">
              <span style="color:rgb(64, 158, 255);">{{ item.title }}</span>
            </el-form-item>
            <el-form-item label="参与人数">
              <span style="color:rgb(64, 158, 255);">: {{ item.joinCount }}</span>
            </el-form-item>
            <el-form-item label="完成人数">
              <span style="color:rgb(64, 158, 255);">: {{ item.doneCount }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column align="center" label="活动id" sortable="custom" prop="id">
        <template slot-scope="scope">
          <span
            style="cursor: pointer;color:#409eff"
            @click="getActivity(scope.row.id)"
          >{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="标题" sortable="custom" prop="title">
        <template slot-scope="scope">
          <span>{{ scope.row.title }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="副标题" sortable="custom" prop="subtitle">
        <template slot-scope="scope">
          <span>{{ scope.row.subtitle }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="完成人数" sortable="custom" prop="doneCount">
        <template slot-scope="scope">
          <span>{{ scope.row.doneCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="完成率" sortable="custom" prop="doneRate">
        <template slot-scope="scope">
          <span>{{ scope.row.doneRate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="报名人数" sortable="custom" prop="joinCount">
        <template slot-scope="scope">
          <span>{{ scope.row.joinCount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="分类id">
        <template slot-scope="scope">
          <span>{{ scope.row.classifyId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="图标" sortable="custom" prop="icon">
        <template slot-scope="scope">
          <img :src="scope.row.icon" style="width:80px;height:80px;object-fit: cover" />
        </template>
      </el-table-column>
      <el-table-column align="center" width="100" sortable="custom" label="是否公开" prop="isPublic">
        <template slot-scope="scope">
          <span>{{ scope.row.isPublic==0?'不公开':'公开' }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="120" label="开始时间">
        <template slot-scope="scope">
          <span v-if="scope.row.holdTime == null">{{ scope.row.startTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="120" label="结束时间">
        <template slot-scope="scope">
          <span v-if="scope.row.holdTime == null">{{ scope.row.endTime}}</span>
          <span v-if="scope.row.holdTime != null">接受后 {{ scope.row.holdTime}}天 结束</span>

        </template>
      </el-table-column>
      <el-table-column align="center" width="120" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="120" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="80" sortable="custom" label="状态" prop="status">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">未开始</span>
          <span v-if="scope.row.status == 1">进行中</span>
          <span v-if="scope.row.status == 2">已结束</span>
          <span v-if="scope.row.status == 3">已关闭</span>
        </template>
      </el-table-column>
        <el-table-column align="center" label="小程序码" width="130">
            <template slot-scope="scope">
                <qrcode :type="17" :params="{value:scope.row.id}"></qrcode>
            </template>
        </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="190">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            style="margin-top: 10px;"
            v-permission:function="['punchTheClockDManger:btn_edit']"
          >编辑</el-button>
          <span v-permission:function="['punchTheClockDManger:btn_colse']">
            <el-button
              size="small"
              type="success"
              @click="offTheShelf(scope.row.id)"
              v-if="scope.row.status != 3"
              style="margin-top: 10px;"
            >关闭</el-button>
          </span>
          <span v-permission:function="['punchTheClockDManger:btn_put']">
            <el-button
              size="small"
              type="success"
              @click="putOnTheShelf(scope.row.id)"
              v-if="scope.row.status == 3"
              style="margin-top: 10px;"
            >开启</el-button>
          </span>

          <el-button
            size="small"
            type="info"
            @click="getCopy(scope.row.id)"
            v-permission:function="['punchTheClockDManger:btn_copy']"
            style="margin-top: 10px;"
          >复制</el-button>
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="width:500px"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getThemeList,
  getThemeUp,
  getThemeDown,
  getOptions
} from '@/api/demo/punchInActivity/index'
import qrcode from '@/components/qrcode.vue'
export default {
  name: 'punchTheClockDManger',
  components: { qrcode },
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      punchTheClockDManger_btn_add: false,
      punchTheClockDManger_btn_edit: false,
      punchTheClockDManger_btn_colse: false,
      punchTheClockDManger_btn_put: false,
      punchTheClockDManger_btn_copy: false,

      tableKey: 0,
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        classifyId: null,
        keyword: null,
        status: null,
        type: '', // 1 显示委托任务 2 显示普通任务
        asc: '', // 排序方式 1 正序 0 倒序
        sortField: '' // 排序字段
      },
      asStatusList: [],
      statusList: [
        { id: 0, name: '未开始' },
        { id: 1, name: '进行中' },
        { id: 2, name: '已结束' },
        { id: 3, name: '已关闭' }
      ],
      showAppoinList: [
        { id: 1, name: '委托任务' },
        { id: 0, name: '恋爱任务' }
      ],
      ascs: [
        { id: 0, name: '倒序' },
        { id: 1, name: '正序' }
      ],
      sortFielList: [
        { id: 'joinCount', name: '报名人数' },
        { id: 'doneCount', name: '完成人数' },
        { id: 'doneRate', name: '完成率' }
      ],
      selectedTime: [], // 时间
      themeData: [], // 活动列表
      total: null,
      listLoading: true // 加载圈圈
    }
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  created () {
    this.listQuery.classifyId = this.$route.query.id
    this.listQuery.keyword = this.$route.query.tiltleId
    this.getClassList()
  },
  mounted () {
    this.getList()
  },
  methods: {
    getClassList () {
      let that = this
      getOptions().then(res => {
        // console.log("megagameClassifyOptions", res);
        that.asStatusList = res
      })
    },
    // 活动列表
    getList (val) {
      let that = this
      if (val) {
        this.listQuery.currentPage = val
      } else {
        this.listQuery.currentPage = 1
      }
      console.log('this.listQuery3', this.listQuery)
      if (this.listQuery.status === '') {
        this.listQuery.status = null
      }
      getThemeList(this.listQuery).then(res => {
        this.listLoading = true
        for (let index = 0; index < res.records.length; index++) {
          let myKey = 'signUpSum'
          let value = 0
          let mykey2 = 'completionRate'
          res.records[index][myKey] = value
          res.records[index][mykey2] = value
          for (var i = res.records[index].tasks.length - 1; i >= 0; i--) {
            if (res.records[index].tasks[i].joinCount == null) {
              let joinCount = 'joinCount'
              let count = 0
              res.records[index].tasks[i][joinCount] = count
            }
            if (res.records[index].tasks[i].doneCount == null) {
              let doneCount = 'doneCount'
              let count = 0
              res.records[index].tasks[i][doneCount] = count
            }
          }
          if (
            res.records[index].doneCount == null &&
            res.records[index].joinCount == null
          ) {
            res.records[index].completionRate = 0
          }
          if (
            res.records[index].doneCount == null &&
            res.records[index].joinCount != null
          ) {
            res.records[index].doneCount = 0
            res.records[index].completionRate = that.returnFloat(
              res.records[index].doneCount / res.records[index].joinCount
            )
          }
          if (
            res.records[index].joinCount == null &&
            res.records[index].doneCount != null
          ) {
            res.records[index].joinCount = 0
            res.records[index].completionRate = that.returnFloat(
              res.records[index].doneCount / res.records[index].joinCount
            )
          }

          if (
            res.records[index].joinCount != null &&
            res.records[index].doneCount != null
          ) {
            res.records[index].completionRate = that.returnFloat(
              res.records[index].doneCount / res.records[index].joinCount
            )
          }
          // console.log(
          //   "res.records[index].doneCount",
          //   res.records[2].completionRate
          // );
        }
        // console.log(
        //   "res.records[index].doneCount",
        //   res.records[2].doneCount,
        //   res.records[2].joinCount
        // );
        this.themeData = res.records
        console.log('res.records', res.records)
        this.total = parseInt(res.total)
        this.listLoading = false
      })
    },
    returnFloat (value) {
      let value2 = Math.round(parseFloat(value) * 10000) / 100
      let xsd = value2.toString().split('.')
      if (xsd.length == 1) {
        value2 = value2.toString() + '.00'
        return value2
      }
      if (xsd.length > 1) {
        if (xsd[1].length < 2) {
          value2 = value2.toString() + '0'
        }
        return value2
      }
    },
    changesa (e) {
      let that = this
      that.listQuery.sortField = e.prop
      // 排序方式 1 正序 0 倒序
      if (e.order == 'ascending') {
        that.listQuery.asc = 1
      } else if (e.order == 'descending') {
        that.listQuery.asc = 0
      } else {
        that.listQuery.asc = null
        that.listQuery.sortField = ''
      }
      that.getList()
      console.log('ee', e)
    },
    // 搜索
    getSearch () {
      let that = this
      that.getList(this.listQuery.currentPage)
    },
    // 添加
    getAdd () {
      this.$router.push({
        path: '/demo/punchTheClock/addToCard'
      })
    },
    // 编辑
    editCard (id) {
      this.$router.push({
        path: '/demo/punchTheClock/addToCard',
        query: {
          id: id
        }
      })
    },
    // 下架
    offTheShelf (id) {
      let that = this
      getThemeDown(id).then(res => {
        that.getList()
        that.$message({
          type: 'success',
          message: '下架成功!'
        })
      })
    },
    // 上架
    putOnTheShelf (id) {
      let that = this
      getThemeUp(id).then(res => {
        that.getList()
        that.$message({
          type: 'success',
          message: '上架成功!'
        })
      })
    },
    // 复制
    getCopy (id) {
      this.$router.push({
        path: './punchTheClock/addToCard',
        query: {
          name: '复制',
          id: id
        }
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    // 跳转到活动id
    getActivity (id) {
      let that = this
      console.log('id', id)
      that.$router.push({
        path: '../demo/record',
        query: {
          themesId: id
        }
      })
    }
  }
}
</script>

<style scoped>
.demo-table-expand2 {
  font-size: 0;
  padding: 50px;
}
.demo-table-expand {
  font-size: 0;
  padding: 1px;
  padding-left: 50px;
  padding-right: 50px;
  /* padding-bottom: 50px; */
}
.demo-table-expand:last-child {
  padding-bottom: 50px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand2 label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 24%;
  color: #000;
  background: #ebf1f6;
  padding-left: 30px;
  margin-bottom: 0px;
  margin-right: 10px;
}
.demo-table-expand2 .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 22%;
  color: #000;
  background: #ebf1f6;
  padding-left: 30px;
  margin-bottom: 0px;
  margin-right: 10px;
}
</style>
